export const formattedDate = (time) => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const date = new Date(time * 1000);
  const day = date.getDate();
  const year = date.getFullYear();
  const month = months[date.getMonth()];

  return `${month} ${day < 10 ? '0' : ''}${day}, ${year}`;
};
